import { createReducer } from "redux-act";
import * as action from "../actions/languageAction";
import { languageCodeExists } from "../../enums/LanguageEnum";

const initialState = {
  language: "sk",
};

const setInitialState = () => {
  let localStorageLanguage = sessionStorage.getItem("language");

  if (languageCodeExists(localStorageLanguage))
    initialState.language = localStorageLanguage;

  return initialState;
};

const languageReducer = createReducer(
  {
    [action.changeLanguage]: (state, payload) => {
      return {
        ...state,
        language: payload,
      };
    },
  },
  setInitialState()
);

export default languageReducer;
